import { useRealtimeConnectionStore } from '../../services/realtime-connection-store';

/**
 * The single <audio> element the agent's voice plays through.
 *
 * Mounted at the app root rather than inside AudioSection, which is where the
 * source project put it. AudioSection here is unmounted whenever the exercise
 * page swaps to its intro/rest branch, and every remount hands the store a new
 * ref — which re-attaches the stream and interrupts playback mid-sentence.
 * At the root it mounts once for the lifetime of the app.
 *
 * No src, no controls, not muted: `srcObject` is assigned programmatically by
 * the store once the remote stream arrives.
 */
const RealtimeAudioOutlet = () => {
  const attachAudioElement = useRealtimeConnectionStore(state => state.attachAudioElement);

  return <audio ref={attachAudioElement} />;
};

export default RealtimeAudioOutlet;
